import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.sendHeartbeat()
    this.timer = setInterval(() => this.sendHeartbeat(), 60000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  async sendHeartbeat() {
    try {
      const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
      await fetch('/api/v1/heartbeat', {
        method: 'POST',
        headers: { 'X-CSRF-Token': token }
      })
    } catch {
      // Silent fail — next heartbeat will retry
    }
  }
}
